<template>
    <div class="tc-context-helper">
        <SVGCopy/>
        <div class="tc-context-helper-text">
          Нажми <span class="tc-bold">Ctrl</span> для перетаскивания с <span class="tc-bold">копированием</span>
        </div>
    </div>
</template>

<script>

import SVGCopy from '@/UI/SVG/SVGCopy.vue';

export default {
    name: 'ContextHelperCtrl',
    components: { SVGCopy },
};
</script>

<style scoped lang="scss">
@import "CSS/lowerHelpers";
.tc-bold {
  color: #00458D;
  font-weight: 600;
}
</style>
